export const LEVEL_TEXT = { high: "High", medium: "Medium", low: "Low" };
export const LEVEL_BADGE = {
  high: { background: "#FCEBEB", color: "#791F1F" },
  medium: { background: "#FAEEDA", color: "#633806" },
  low: { background: "#EAF3DE", color: "#27500A" },
};
export const LEVEL_SQUARE = { high: "#E24B4A", medium: "#E0922F", low: "#1D9E75" };
export const LEVEL_TEXT_COLOR = { high: "#E24B4A", medium: "#BA7517", low: "#73726c" };
export const CAT_COLOR = {
  customer: "#E24B4A",
  geographic: "#378ADD",
  supplier: "#7F77DD",
  product: "#BA7517",
  credit: "#1D9E75",
};
export const DIM_ORDER = ["customer", "geographic", "supplier", "product", "credit"];

export function RiskBadge({ level, label, testid }) {
  const lv = level || "low";
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold font-data"
      style={LEVEL_BADGE[lv]}
    >
      {label || LEVEL_TEXT[lv]}
    </span>
  );
}

export function RiskBlocks({ scores }) {
  return (
    <div className="flex items-center gap-1">
      {DIM_ORDER.map((d) => (
        <span
          key={d}
          title={`${d}: ${scores[d] || "—"}`}
          className="inline-block h-3.5 w-3.5 rounded-sm"
          style={{ backgroundColor: scores[d] ? LEVEL_SQUARE[scores[d]] : "#e8e6df" }}
        />
      ))}
    </div>
  );
}
